<template>
	<div class="wikidata-search-container">
		<table class="mb-2" v-show="selectedTags.length > 0">
			<tr>
				<td>
					<span v-for="(tag, index) in selectedTags" v-if="tag.action !== 'DELETE'" @click="deselectTag(tag)" :key="'selected-tag-' + index" class="badge badge-tag" :class="tag.class">
						{{tag.wikidata_label}}
						<i class="far fa-trash-alt ml-1"></i>
					</span>
				</td>
			</tr>
		</table>

		<div class="wikidata-search-input pb-3">
			<div class="input-group">
				<input type="text" :placeholder="__('translations.label.search')" v-model="query" @focus="$event.target.select()" class="form-control" name="query" id="query" autocomplete="off" ref="search" />
				<div class="input-group-append">
					<span v-if="!isSearching" class="input-group-text"><i class="fas fa-search"></i></span>
					<span v-else class="input-group-text">
						<div class="spinner-border spinner-border-sm" role="status">
							<span class="sr-only">Loading...</span>
						</div>
					</span>
				</div>
			</div>
		</div>
		
		<div class="wikidata-results">
			<table class="mb-2" v-if="(recentlyUsedTags.length > 0 || mostUsedTags.length > 0) && query === ''">
				<tr v-show="recentlyUsedTags.length > 0">
					<td class="align-top" style="width: 100px">{{ __('translations.title.recently_used_tags') }}</td>
					<td><span v-for="tag in recentlyUsedTags" @click="selectTag(tag)" :key="'recently-used-tag-' + tag.id" class="badge badge-tag">
							{{tag.label}}
							<i class="fas fa-plus ml-1"></i>
						</span>
					</td>
				</tr>
				<tr v-show="mostUsedTags.length > 0">
					<td class="align-top" style="width: 100px">{{ __('translations.title.most_used_tags') }}</td>
					<td><span v-for="tag in mostUsedTags" @click="selectTag(tag)" :key="'most-used-tag-' + tag.id" class="badge badge-tag">
							{{tag.label}}
							<i class="fas fa-plus ml-1"></i>
						</span>
					</td>
				</tr>
			</table>
			<span v-if="query !== '' && isSearched">
				<div v-if="results.length === 0" class="text-muted mb-1">
					{{ __('translations.message.no_result_found') }}
				</div>
				<ul v-else class="list-group list-group-flush">
					<li v-for="result in results" :key="result.id" class="list-group-item d-flex justify-content-between align-items-center px-1 py-2">
						<span>
							<p class="wikidata-label mb-0" @click="selectTag(result)">
								<b>{{result.label}} ({{result.id}})</b>
								<i v-if="result.pageid === null" class="fas fa-history ml-1" style="vertical-align: middle; font-size: 14px"></i>
							</p>
							<p class="wikidata-desc text-muted mb-0">{{result.description}}</p>
						</span>
						<a :href="result.concepturi" target="_blank" class="pl-2 py-2">
							<i class="fas fa-external-link-alt"></i>
						</a>
					</li>
				</ul>
			</span>
		</div>
	</div>
</template>

<script>
import Util from '../mixins/Util'
import _ from 'lodash'

export default {
	mixins: [Util],
	data() {
		return {
			query: '',
			results: [],
			isSearching: false,
			isSearched: false,
			selectedTags: [],
		}
	},
	props: {
		taggableType: String,
		populateWith: {
			type: Array,
			default: () => []
		}
	},
	watch: {
		query: {
			handler: _.debounce(function () {
				if(this.query !== '') {
					this.isSearching = true;
					this.isSearched = false;
					this.search();
				} else {
					this.results = [];
	 				this.isSearched = false;
	 				this.isSearching = false;
				}
			}, 500)
		}
	},
	created() {
		this.getMostUsedTags(this.taggableType);
		this.getRecentlyUsedTags(this.taggableType);

		this.selectedTags = this.populateWith;
	},
	mounted() {
		this.$refs.search.focus();
	},
	methods: {
		search() {
			axios.get('/wikidata/search', {params: {query: this.query}}).then(response => {
				this.results = response.data;
				this.isSearched = true;
				this.isSearching = false;
			}).catch(err => {
				console.log(err)
			})
		},
		selectTag(tag) {
			// To see if the newly selected tag already exists.
			var tagExists = this.selectedTags.filter(function(t) {
				if (t.action !== 'DELETE' && t.wikidata_id === tag.id) {
					Vue.set(t, 'class', 'tag-warning');
					setTimeout(function () {
						// Remove the class after the highlight animation had been finished.
						Vue.set(t, 'class', '');
					}, 600);
					
					return t;
				}
			});
			
			// Emit tag only if it doesn't exist in the already selected tags.
			if(tagExists.length === 0) {
				if (this.taggableType === 'annotation') {
					this.$emit('selected-tag', {
						'wikidata_id': tag.id,
						'wikidata_label': tag.label,
						'wikidata_desc': tag.description,
					});
				} else {
					this.$emit('selected-tag', tag);
				}
			}
			
			this.$refs.search.focus();
		},
		deselectTag(tag) {
			this.$emit('deselected-tag', tag);
			this.$refs.search.focus();
		}
	}
}
</script>